module.exports = __webpack_public_path__ + "static/media/Development.a63d66ac.md";